import { StreamEl } from '@mi-front/ui';
import { TsThumbnail } from '../../../../../../../core/thumbnails/components/TsThumbnail';
import { THUMBNAIL_HEIGHT } from '../../../../../../../core/thumbnails/consts';

interface Props {
  stationId: string;
  ts: number;
}

export function StreamThumbnail({ stationId, ts }: Props) {
  return (
    <StreamEl
      ts={ts}
      checkOverflow
      offsetX={10}
      offsetY={THUMBNAIL_HEIGHT / 2 + 20}
      zIndex={100}
      position="center"
      noEvents
    >
      <TsThumbnail
        stationId={stationId}
        ts={ts}
        theme={'dark'}
        useThumbnailOptions={{
          fetchRangeMinutes: 30,
        }}
      />
    </StreamEl>
  );
}
